import { MouseEvent, ReactNode } from 'react'

export type AlertTheme = {
  background: string
}

export const variants = {
  INFO: 'info',
  DANGER: 'danger',
  SUCCESS: 'success',
  WARNING: 'warning'
} as const

export type Variants = (typeof variants)[keyof typeof variants]

export interface CommonAlertProps {
  variant?: Variants
  title: string | React.ReactNode
  children?: ReactNode
  onClick?: (evt: MouseEvent<HTMLButtonElement>) => void
}

export type ConditionalTextProps =
  | {
      buttonText: string
      onButtonClick: (evt: MouseEvent<HTMLButtonElement>) => void
    }
  | {
      buttonText?: never
      onButtonClick?: () => never
    }

export type AlertProps = CommonAlertProps & ConditionalTextProps
